import PapaParse from 'papaparse'

import { ResolvedAIReviewSection } from 'src/pages/module-review/moduleAIReviewPages'

export const AI_REVIEW_CSV_HEADERS = [
    'Page',
    'Section',
    'Severity',
    'Rule',
    'Comment',
    'Item label',
    'Attribute path',
    'Locale',
]

// Lets Excel detect UTF-8, since comments quote translated text.
const UTF8_BOM = '\uFEFF'

/**
 * One row per AI review finding and locale, in the order the review shows them, so other tools can
 * filter by locale. Cells a spreadsheet would run as a formula are escaped, since the comments come
 * from a model and quote the draft.
 */
export function buildAIReviewCsv(sections: readonly ResolvedAIReviewSection[]): string {
    const rows: (string | number)[][] = []
    for (const section of sections) {
        for (const finding of section.findings) {
            for (const instance of finding.instances) {
                rows.push([
                    finding.pageNumber ?? 'Module-wide',
                    section.title ?? section.sectionId,
                    instance.severity,
                    instance.ruleId,
                    instance.message,
                    finding.itemLabel ?? instance.entityId ?? '',
                    instance.attributePath ?? '',
                    instance.locale ?? '',
                ])
            }
        }
    }
    return (
        UTF8_BOM +
        PapaParse.unparse({ fields: AI_REVIEW_CSV_HEADERS, data: rows }, { escapeFormulae: true })
    )
}
